import React from 'react';
import PropTypes from 'prop-types';
import CharityImage from 'components/CharityImage/CharityImage';
import './SelectList.scss';

const SelectList = ({ showRadioIcon, items, selectedId, onSelect, labelKey, idKey }) => (
  <ul className="select-list" role="radiogroup">
    { items
        .filter((item) => !selectedId || selectedId === item[idKey])
        .map((item) => (
          <li
            key={item[idKey]}
            className={`select-list__item ${item[idKey] === selectedId && '--selected'} ${showRadioIcon && '--radio-icon'}`}
          >
            <a
              href=""
              className="select-list__item__inner"
              role="radio"
              aria-checked={item[idKey] === selectedId}
              tabIndex="0"
              onClick={onSelect}
              data-id={item[idKey]}
            >
              <div className="select-list__item__pic__wrapper">
                <CharityImage
                  src={item.charityImageUrl}
                  alt={item.charityName}
                  classNames="select-list__item__pic"
                />
              </div>

              {item[labelKey]}
            </a>
          </li>
        ),
    )}
  </ul>
);

SelectList.propTypes = {
  showRadioIcon: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedId: PropTypes.number,
  labelKey: PropTypes.string,
  idKey: PropTypes.string,
  onSelect: PropTypes.func,
};

SelectList.defaultProps = {
  showRadioIcon: false,
  items: [],
  selectedId: null,
  labelKey: 'label',
  idKey: 'id',
  onSelect: () => {},
};

export default SelectList;



// WEBPACK FOOTER //
// ./components/SelectList/SelectList.js